import React, { useState, useEffect, useContext } from 'react';
import { BiSolidEditAlt } from 'react-icons/bi';
import { CiEdit } from 'react-icons/ci';
import { FaEdit, FaRegWindowClose } from 'react-icons/fa';
import { IoNewspaperOutline, IoSearchSharp } from 'react-icons/io5';
import { MdDeleteForever } from 'react-icons/md';
import Breadcrumb from '../components/Breadcrumb';
// import Select, { components } from 'react-select';
import Select from 'react-dropdown-select';
import { TiTick } from 'react-icons/ti';
import { Link, useSearchParams } from 'react-router-dom';
import { DataContext } from '../context/DataProvider';
import ReactPaginate from 'react-paginate';
import { GrFormNext, GrFormPrevious } from 'react-icons/gr';
import SearchLawDropDown from '../SearchableDropDown/SearchLawDropDown';
import { format as jalaliFormat } from 'date-fns-jalali';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
const NewOrgans = () => {
  const {
    userInfo,
    expire,
    expireToken,
    tokenLogin,
    fetchRefreshToken,
    isTokenExpired,
    edame,
    OptionSearch,
    setOption,
  } = useContext(DataContext);
  console.log(OptionSearch);
  const [value, setValue] = useState([]);
  const [pageSize, setPageSize] = useState(30);
  const [organInfo, setOrganInfo] = useState({
    sectionId: 0,
    lawId: 0,
    orgIds: '',
  });

  const [fromDate, setfromDate] = useState(null);
  const [ToDate, setToDate] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [searchParams, setsearchParams] = useSearchParams();
  const page: any = searchParams.get('page');
  const [listExecutor, setListExecutor] = useState([]);
  const [listExecutorcount, setListExecutorcount] = useState(0);
  const [isLoading, setisLoading] = useState(true);
  const [Search, setSeach] = useState(OptionSearch);
  const [SearchPage, setSearchPage] = useState(1);
  const [SearchResult, setSearchResult] = useState([]);
  const [SearchResultcount, setSearchResultcount] = useState(0);
  const [listorgans, setOrgans] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  let [organforEdit, setOrganforEdit] = useState([]);
  const [savePage, setSavePage] = useState(1);
  const [isReplated, setIsReplated] = useState(false);
  let rowNumber = page ? (page - 1) * pageSize : 0;
  function deHilight(str) {
    return str
      .replaceAll(/\n/g, ' ')
      .replaceAll('</e>', ' ')
      .replaceAll('</b>', ' ')
      .replaceAll('<e>', ' ')
      .replaceAll('<b>', ' ')
      .replaceAll('\x9D', '  ')
      .replaceAll(' ', '  ');
  }
  const FetchListExecutor = async (currentPage: any) => {
    await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/Admin/ListExecutor?size=${pageSize}&page=${currentPage}`,
    )
      .then((res) => res.json())
      .then((data) => {
        return setListExecutor(data.data), setListExecutorcount(data.count);
      })
      .finally(() => setisLoading(false));
  };
  const FetchSearch = async () => {
    // if(token){
    // if (!expire) {
    fetch(
      `${
        process.env.REACT_APP_BASE_URL
      }/api/Admin/ListExecutor?size=${pageSize}&page=${SearchPage}${
        Search !== '' ? '&search=' + Search : ''
      }`,
    )
      .then((res) => res.json())
      .then((data) => {
        return setSearchResult(data.data), setSearchResultcount(data.count);
      })
      // .catch((error) => {expireToken() })
      .finally(() => setisLoading(false));
  };
  const FetchOrgans = async () => {
    await fetch(`${process.env.REACT_APP_BASE_URL}/api/Data/Orgs?exec=true`)
      .then((res) => res.json())
      .then((data) => setOrgans(data))
      .finally(() => setisLoading(false));
  };
  const q = [];

  const fetchEdit = async () => {
    console.log(isTokenExpired(tokenLogin.data?.accessToken));
    // if(tokenLogin){
    if (!isTokenExpired(tokenLogin.data?.accessToken)) {
      await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/Admin/DelsertExecutor?sectionId=${organInfo.sectionId}&lawId=${organInfo.lawId}&orgIds=${organInfo.orgIds}`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
          },
        },
      ).then((res) => {
        if (res.status === 200) {
          setOpenModal(false);
          if (Search !== '') {
            FetchSearch();
          } else {
            FetchListExecutor(page ? page : 1);
          }
        }
      });
    } else {
      fetchRefreshToken();
    }
  };
  useEffect(() => {
    FetchListExecutor(page ? page : 1);
    FetchOrgans();
  }, [expire, pageSize, SearchPage]);

  const afterpagehandle = async (data: any) => {
    setsearchParams({ page: data.selected + 1 });
    FetchListExecutor(data.selected + 1);
    // setisLoading(true);
    console.log(listExecutor);
  };
  const changePageSearch = (data: any) => {
    setsearchParams({ page: data.selected + 1 });
    setSearchPage(data.selected + 1);
    // setisLoading(true)
  };
  let a = [];
  const GetInfoForEdit = (item: {}) => {
    setOpenModal(true);

    console.log('!!!!!!', item.OrgIDs);

    if (item.OrgIDs !== null) {
      if (item.OrgIDs.includes(',')) {
        console.log('object');
        let x = item.OrgIDs.split(',');
        console.log(x);
        for (let i = 0; i < x.length; i++) {
          const c = x[i];

          const z = listorgans.find((i) => i.ID === Number(c));
          a.push(z);

          setOrganforEdit(a);
        }
      } else {
        console.log('else');
        const z = listorgans.find((i) => i.ID == item.OrgIDs);

        console.log('@@@', z);
      }
    } else {
      setOrganInfo({
        ...organInfo,
        sectionId: item.Section_ID,
        lawId: item.Law_ID,
      });
    }
    setOrganInfo({
      ...organInfo,
      sectionId: item.Section_ID,
      lawId: item.Law_ID,
    });
  };
  console.log(organInfo);
  const handleChangeSelect = (value) => {
    setValue(value);
    console.log(value);
    value.forEach((item) => {
      q.push(item.ID);
      const z = q.join().toString();
      console.log('z', z);
      setOrganInfo({
        ...organInfo,
        orgIds: z,
      });
    });
  };
  const changePageSize = (e) => {
    if (page !== 1 || !page) {
      setsearchParams({});
      setPageSize(parseInt(e.target.value));
    } else {
      setPageSize(parseInt(e.target.value));
    }
  };

  const [Type, setType] = useState(8);
  const handlefromDate = (date: Date) => {
    setfromDate(jalaliFormat(new Date(date), 'yyyy/MM/dd'));
  };
  const handleToDate = (date: Date) => {
    setToDate(jalaliFormat(new Date(date), 'yyyy/MM/dd'));
  };
  const changeType = (e) => {
    if (e.target.value === 'null') {
      setType('null');
    } else {
      setType(e.target.value);
    }
  };

  const isReplatedChecked = async (e) => {
    console.log(e.target.checked);
    setIsReplated(e.target.checked);
  };

  return (
    <>
      <Breadcrumb pageName="دستگاه های مجری" />
      <div className="w-full max-w-full p-10 rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <div className="w-full flex items-center justify-between">
          <div className="w-full flex items-center">
            <input
              onChange={(e) => setSeach(e.target.value)}
              className="border-2 w-[90%] relative border-[#E5E1DA] outline-none p-2 rounded-lg m-8 text-[16px]"
              style={{ fontFamily: 'IranSans' }}
              placeholder="جستجوی قانون"
            />
          </div>
          <div className="w-full flex items-center">
            <div className="w-full  md:mt-0 mt-3 flex items-center ">
              <div className="w-full flex items-center  ">
                <label className="ml-3">از </label>
                <DatePicker
                  className="custom-calendar"
                  inputClass="custom-input"
                  calendarPosition="bottom-center"
                  value={fromDate}
                  locale={persian_fa}
                  calendar={persian}
                  onChange={handlefromDate}
                />
              </div>
            </div>
            <div className="w-full  md:mt-0 mt-3 flex items-center ">
              <div className="w-full flex items-center ">
                <label className="ml-3 mr-3">تا </label>
                <DatePicker
                  className="custom-calendar"
                  inputClass="custom-input"
                  calendarPosition="bottom-center"
                  value={ToDate}
                  locale={persian_fa}
                  calendar={persian}
                  onChange={handleToDate}
                />
              </div>
            </div>
            {/* type */}
            <div className="w-full mr-3 md:mt-0 mt-3 flex items-center ">
              <select
                onChange={changeType}
                className="border w-[90%] relative border-[#E5E1DA] outline-none p-2 rounded-lg text-[14px]"
              >
                <option value="null">نوع</option>
                <option value="1"></option>
                <option value="2"></option>
              </select>
            </div>
            <div className="flex w-full items-center mt-3 mb-4 ml-3">
              <input
                onChange={isReplatedChecked}
                id="default-checkbox"
                type="checkbox"
                value=""
                className="w-7 h-7 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
              />
              <label
                for="default-checkbox"
                className="ms-2 text-sm font-[16px] text-gray-900 dark:text-gray-300 ml-3"
              >
                نمایش همه منسوخه ها
              </label>
            </div>
          </div>
          <div className="bg-[#FD02] ml-24">
            <button className="button" onClick={FetchSearch}>
              <IoSearchSharp size={35} className="svgIcon " />
            </button>
          </div>
          <div className="w-full ">
            <button>
              <div className="box font-IranSans text-[16px]">
                تشخیص هوشمند NER
              </div>
            </button>
          </div>
        </div>
        {/* table */}
        <div className="w-full mt-3">
          <table className="w-full">
            <thead>
              <tr className="font-IranSans w-full bg-[#B1B2FF] text-[#030637]">
                <th className="w-10 border-b p-3 text-[14px] text-center">
                  ردیف
                </th>
                <th className="w-[30rem] border-b p-3 text-[14px] text-center">
                  عنوان قانون
                </th>
                <th className="w-10 border-b p-3 text-[14px] text-center">
                  دستگاه اجرایی
                </th>
              </tr>
            </thead>
            <tbody>
              {SearchResult.length === 0 ? (
                <>
                  {listExecutor.map((item, index) => {
                    return (
                      <>
                        <tr className="">
                          <td className="w-10 border-b p-4 text-[15px] font-IranSans text-center ">
                            {' '}
                            {(rowNumber = rowNumber + 1)}
                          </td>
                          <td className="w-[30rem] border-b p-4 text-[15px] font-IranSans text-center  ">
                            <Link
                              target="_blank"
                              to={`https://ilaws.net/ViewText/${item.ID}`}
                            >
                              <div className="font-medium text-black dark:text-white">
                                {deHilight(item.LawTitle)}
                              </div>
                            </Link>
                          </td>
                          <td className="w-10  border-b  p-4 font-IranSans text-center">
                            {item.OrgTitles !== null ? (
                              <div
                                onClick={() => GetInfoForEdit(item)}
                                className="bg-[#38bdf8] text-[15px] font-IranSans w-[100%] p-1 text-[#ffffff] shadow-md rounded-lg cursor-pointer hover:text-[#38bdf8] border hover:border-[#38bdf8] hover:bg-[#ffffff]"
                              >
                                {item.OrgTitles}
                              </div>
                            ) : (
                              <></>
                            )}
                          </td>
                        </tr>
                      </>
                    );
                  })}
                </>
              ) : (
                <>
                  {SearchResult.map((item, index) => {
                    return (
                      <>
                        <tr className="">
                          <td className="w-10 border-b p-4 text-[15px] font-IranSans text-center ">
                            {' '}
                            {(rowNumber = rowNumber + 1)}
                          </td>
                          <td className="w-[30rem] border-b p-4 text-[15px] font-IranSans text-center  ">
                            <Link
                              target="_blank"
                              to={`https://ilaws.net/ViewText/${item.ID}`}
                            >
                              <div className="font-medium text-black dark:text-white">
                                {deHilight(item.LawTitle)}
                              </div>
                            </Link>
                          </td>
                          <td className="w-10  border-b  p-4  font-IranSans  text-center">
                            {item.OrgTitles !== null ? (
                              <>
                                <div
                                  onClick={() => GetInfoForEdit(item)}
                                  className="bg-[#38bdf8] text-[15px] font-IranSans w-[100%] p-1 text-[#ffffff] shadow-md rounded-lg cursor-pointer hover:text-[#38bdf8] border hover:border-[#38bdf8] hover:bg-[#ffffff]"
                                >
                                  {item.OrgTitles}
                                </div>
                              </>
                            ) : (
                              //   <div  onClick={() => GetInfoForEdit(item)}  className="bg-[#38bdf8] text-[15px] font-IranSans w-[100%] p-1 text-[#ffffff] shadow-md rounded-lg cursor-pointer hover:text-[#38bdf8] border hover:border-[#38bdf8] hover:bg-[#ffffff]"
                              //   >
                              //   ویرایش
                              //  </div>
                              <></>
                            )}
                          </td>
                        </tr>
                      </>
                    );
                  })}
                </>
              )}
            </tbody>
          </table>
        </div>
        <div>
          {SearchResult.length === 0 ? (
            <>
              <div className="w-full flex items-center justify-between">
                <div className="flex w-full items-center font-IranSans">
                  <label className="text-[16px]">تعداد نمایش در صفحه </label>
                  <select
                    className="border p-1 mr-3 font-IranSans rounded-lg border-gray-400 outline-none"
                    onChange={changePageSize}
                    value={pageSize}
                  >
                    <option value="10">10</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="300">300</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                  </select>
                </div>
                <div className="font-IranSans w-full">
                  <ReactPaginate
                    breakLabel={<span className="mr-4 sm:mr-0">...</span>}
                    nextLabel={
                      <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md mr-4 sm:mr-2 sm:p-2">
                        <BsChevronLeft />
                      </span>
                    }
                    onPageChange={afterpagehandle}
                    pageRangeDisplayed={5}
                    pageCount={Math.ceil(listExecutorcount / pageSize)}
                    previousLabel={
                      <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md">
                        <BsChevronRight />
                      </span>
                    }
                    initialPage={savePage - 1}
                    containerClassName="flex items-center justify-center mt-4 mb-4 flex-wrap"
                    pageClassName="block border- border-solid border-[#D3D3D3] hover:bg-gray-200 w-10 h-10  flex items-center justify-center rounded-md mr-4"
                    activeClassName={
                      savePage ? 'bg-[#06b6d4] text-white hover:text-black' : ''
                    }
                    // current
                  />

                  {/* <ReactPaginate
                    className="PaginateBody"
                    previousLabel={<GrFormNext size={25} />}
                    nextLabel={<GrFormPrevious size={25} />}
                    // previousLabel={"صفحه قبل "}
                    // nextLabel={"صفحه بعد "}
                    // breakLabel={"..."}
                    pageCount={Math.ceil(listExecutorcount / pageSize)}
                    marginPagesDisplayed={4}
                    onPageChange={afterpagehandle}
                    pageClassName={'reactPaginate'}
                    previousClassName={'previous'}
                    nextClassName={'Next'}
                    breakClassName={'break'}
                  /> */}
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="w-full flex items-center justify-between">
                <div className="flex w-full items-center font-IranSans">
                  <label className="text-[16px]">تعداد نمایش در صفحه </label>
                  <select
                    className="border p-1 mr-3 font-IranSans rounded-lg border-gray-400 outline-none"
                    onChange={changePageSize}
                    value={pageSize}
                  >
                    <option value="10">10</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="300">300</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                  </select>
                </div>
                <div className="w-full font-IranSans">
                  <ReactPaginate
                    breakLabel={<span className="mr-4 sm:mr-0">...</span>}
                    nextLabel={
                      <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md mr-4 sm:mr-2 sm:p-2">
                        <BsChevronLeft />
                      </span>
                    }
                    onPageChange={changePageSearch}
                    pageRangeDisplayed={5}
                    pageCount={Math.ceil(SearchResultcount / pageSize)}
                    previousLabel={
                      <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md">
                        <BsChevronRight />
                      </span>
                    }
                    initialPage={savePage - 1}
                    containerClassName="flex items-center justify-center mt-4 mb-4 flex-wrap"
                    pageClassName="block border- border-solid border-[#D3D3D3] hover:bg-gray-200 w-10 h-10  flex items-center justify-center rounded-md mr-4"
                    activeClassName={
                      savePage ? 'bg-[#06b6d4] text-white hover:text-black' : ''
                    }
                  />
                  {/* <ReactPaginate
                    className="PaginateBody"
                    previousLabel={<GrFormNext size={25} />}
                    nextLabel={<GrFormPrevious size={25} />}
                    // previousLabel={"صفحه قبل "}
                    // nextLabel={"صفحه بعد "}
                    // breakLabel={"..."}
                    pageCount={Math.ceil(SearchResultcount / pageSize)}
                    marginPagesDisplayed={4}
                    onPageChange={changePageSearch}
                    pageClassName={'reactPaginate'}
                    previousClassName={'previous'}
                    nextClassName={'Next'}
                    breakClassName={'break'}
                  /> */}
                </div>
              </div>
            </>
          )}
        </div>
        {openModal && (
          <div className="ModalBackground">
            <div className="Modal-innerOrgans">
              <FaRegWindowClose
                onClick={() => setOpenModal(false)}
                className="mb-2"
                size={25}
              />

              <div className="text-2xl w-full p-5 text-black font-IranSans font-bold">
                دستگاه اجرایی
              </div>
              <div className="w-full  border-2 border-[#E5E1DA] rounded-lg p-5 font-IranSans">
                <div className="w-full grid grid-cols-1 gap-10 h-full ">
                  <div className="w-full  items-center justify-center flex ">
                    <label className="ml-5 h-full  w-[30%] text-[16px] font-IranSans">
                      دستگاه (ها) اجرایی
                    </label>
                    {organforEdit.lenght !== 0 ? (
                      <div className="w-[70%] rtl">
                        {/* <Select
                          style={{
                            fontFamily: 'Bmitra',
                            fontSize: '27px',
                            direction: 'rtl',
                            height: '50px',
                          }}
                          options={listorgans}
                          labelField="Title"
                          valueField="Title"
                          name="select"
                          multi
                          values={organforEdit}
                          searchable={true}
                          placeholder="دستگاه (ها) اجرایی"
                          onChange={handleChangeSelect}
                        /> */}
                      </div>
                    ) : (
                      <div className="w-full rtl">
                        <Select
                          style={{
                            fontFamily: 'IranSans',
                            fontSize: '27px',
                            direction: 'rtl',
                            height: '50px',
                          }}
                          options={listorgans}
                          labelField="Title"
                          valueField="Title"
                          name="select"
                          multi
                          searchable={true}
                          placeholder="دستگاه (ها) اجرایی"
                          onChange={handleChangeSelect}
                        />
                      </div>
                    )}
                  </div>
                </div>

                <div className=" flex gap-5 w-full mt-10 ltr p-5">
                  <button
                    className="w-40 p-2 rounded-full text-[16px] text-white flex items-center justify-center
             bg-[#867AE9] font-bold hover:border-2 hover:shadow-2xl hover:shadow-black font-IranSans"
                    onClick={fetchEdit}
                  >
                    تایید <TiTick className="ml-3" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default NewOrgans;
